import { FC, ReactNode, useContext } from 'react';
import { Affix, Space } from '@mantine/core';
import { BrowserS } from '../../../Service/BrowserS';
import { WindowContext } from '../../../Service/Context/WindowContext';

const InjectableFooter: FC<{ children: ReactNode }> = ({ children }) => (
  <>
    <Space pos="fixed" h={BrowserS.runningAsPWA ? 85 : 60} sx={{ bottom: 0 }} />
    <Affix
      position={{ bottom: 0 }}
      sx={(theme) => ({
        height: BrowserS.runningAsPWA ? 85 : 60,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : '#fff',
        borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]}`,
        width: '100%',
      })}
    >
      {children}
    </Affix>
  </>
);

export const FooterGap = () => {
  const { sm } = useContext(WindowContext);
  if (sm) {
    return <Space h={BrowserS.runningAsPWA ? 85 : 60} />;
  }
  return null;
};

export default InjectableFooter;
